import React from 'react';

import initPolyglot from '~/src/utilities/libs/polyglot';
import {convertDate} from '~/src/utilities/helpers/date';
import {classNames} from '~/src/utilities/helpers/css';
import {withSettingsContext} from '~/src/components/context/SettingsContext';

import css from './PublishDate.module.scss';
import i18nStrings from './PublishDate.i18n.json';

const getTranslation = initPolyglot(i18nStrings);

class PublishDate extends React.Component {
    updateDateCall = () => {
        const delta = new Date() - new Date(this.props.publishedTime);

        this.setState({delta}, () => {
            if (delta < 24 * 60 * 60 * 1000) {
                const base = delta < 1000 * 60 * 60 ? 60 * 1000 : 60 * 60 * 1000;
                const deltaBase = delta % base;
                const timeout = base - deltaBase;

                this.timeoutId = setTimeout(this.updateDateCall, timeout);
            }
        });
    };

    getTimeString() {
        const deltaMin = Math.ceil(this.state.delta / 1000 / 60);

        if (deltaMin < 60) {
            return `${getTranslation('timePassed')} ${deltaMin}min`;
        }

        if (deltaMin < 24 * 60) {
            return `${getTranslation('timePassed')} ${Math.floor(deltaMin / 60)}h`;
        }

        return convertDate(this.props.publishedTime).replace(/,/g, '');
    }

    state = {
        delta: new Date() - new Date(this.props.publishedTime)
    };

    componentDidMount() {
        this.updateDateCall();
    }

    componentWillUnmount() {
        clearTimeout(this.timeoutId);
    }

    render() {
        const {settings} = this.props.context;
        const classes = classNames(css, 'publishDate', settings.siteArea);
        return (
            <div className={classes}>
                {this.props.isUpdated && `${getTranslation('updated')} `}
                {this.getTimeString()}
            </div>
        );
    }
}

export default withSettingsContext(PublishDate);
